import React from "react";
import "./relig.css";


function Relig() {
  return (
    <>
      <div className="content">
        <div className="lang-1">
          <h3 > Diversity in Religion </h3>
          <p>
            {" "}
            Religion in India is characterised by a diversity of religious
            beliefs and practices. The preamble of Indian constitution states
            that India is a secular state. There is separation of the state and
            religion, such as religious instructions cannot be imparted at
            public schools and political parties cannot ask for votes during
            elections in the name of religion. The Indian subcontinent is the
            birthplace of four of the world's major religions; namely Hinduism,
            Buddhism, Jainism, and Sikhism. According to the 2011 census, 79.8%
            of the population of India practices Hinduism, 14.2% adheres to
            Islam, 2.3% adheres to Christianity, 1.7% adheres to Sikhism, 0.7%
            adheres to Buddhism and 0.4% adheres to Jainism. Zoroastrianism,
            Sanamahism and Judaism also have an ancient history in India, and
            each has several thousands of Indian adherents. India has the
            largest population of people adhering to Zoroastrianism (i.e. Parsis
            and Iranis) and Bahá'í Faith in the world, even though these
            religions initially grew in Persia. Throughout India's history,
            religion has been an important part of the country's culture.
            Religious diversity and religious tolerance are both established in
            the country by the law and custom; the Constitution of India has
            declared the right to freedom of religion to be a fundamental right.
          </p>
        </div>
        <div className="container-rel">
        <div className="card-rel">
          <div className="bg-image">
            <img src="https://omf.org/ca/wp-content/uploads/bfi_thumb/Hinduism_1-obbksy88tu6ae5w2ras4nkmw35ef8i01ab9hf06jds.jpg" alt="bla" />
          </div>
          <div className="info">
            <h3>Hinduism</h3>
          </div>
        </div>
        <div className="card-rel">
          <div className="bg-image">
            <img src="https://upload.wikimedia.org/wikipedia/commons/thumb/8/81/Flagge_Sikhism.svg/1200px-Flagge_Sikhism.svg.png" alt="bla" />
          </div>
          <div className="info">
            <h3>Sikhism</h3>
          </div>
        </div>
        <div className="card-rel">
          <div className="bg-image">
            <img src="https://png.pngitem.com/pimgs/s/187-1875593_muslim-symbol-transparent-background-hd-png-download.png" alt="bla" />
          </div>
          <div className="info">
            <h3>Islamism</h3>
          </div>
        </div>
        <div className="card-rel">
          <div className="bg-image">
            <img src="https://media.istockphoto.com/vectors/symbol-of-a-church-cross-christianity-religion-symbol-vector-id1017466820?k=20&m=1017466820&s=170667a&w=0&h=-9zYrM3thnRO8z9vXTX1EiDXH3xSUV15q5ZpUW9yrV0=" alt="bla" />
          </div>
          <div className="info">
            <h3>Christianity</h3>
          </div>
        </div>
        <div className="card-rel">
          <div className="bg-image">
            <img src="https://m.media-amazon.com/images/I/71LC9W7TBQL._SY355_.jpg" alt="bla" />
          </div>
          <div className="info">
            <h3>Jainism</h3>
          </div>
        </div>
        <div className="card-rel">
          <div className="bg-image">
            <img src="https://www.santabanta.com/images/wallpapers/spiritual/a-buddhist-symbol-1024-768-0.jpg" alt="bla" />
          </div>
          <div className="info">
            <h3>Buddhism</h3>
          </div>
        </div>
      
      </div>
      </div>
    </>
  );
}

export default Relig;
